import React from 'react';
import Layout from '../../components/layout/Layout';
import ResetPassword from '../../components/auth/ResetPassword';
import AnalyticsWrapper from '../../components/common/AnalyticsWrapper';

const ResetPasswordView = () => {
  return (
    <AnalyticsWrapper>
      <Layout title="Reset password">
        <ResetPassword />
      </Layout>
    </AnalyticsWrapper>
  );
};

export default ResetPasswordView;
